import React, { useState, useEffect, forwardRef } from 'react';
import Tabler from './Tabler.jsx'
import moment from 'moment';

const TableUser = forwardRef((props,ref) => {
	const columns = [
		{"dataIndex": ["login"], "title": "Login", "width": 100, fixed:'left', "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["name"], "title": "Jméno", "width": 150, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["phone"], "title": "Telefon", "width": 150, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["email"], "title": "E-mail", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}},
		//{"dataIndex": ["admin"], "title": "Admin", "width": 100, "options": {"type": "bool", "sortable": true, "searchable": true}},
		{"dataIndex": ["credt"], "title": "Dat. vytvoř.", "width": 130, "options": {"type": "date", "sortable": true, "searchable": true},render:(_, r) => moment(r.credt).format('DD.MM.YYYY')},
		{"dataIndex": ["creby", "name"], "title": "Vytvořil", "width": 100, "options": {"type": "text", "sortable": true, "searchable": true}},  
		{"dataIndex": ["moddt"], "title": "Dat. modif.", "width": 130, "options": {"type": "date", "sortable": true, "searchable": true}, render:(_, r) => moment(r.moddt).format('DD.MM.YYYY')},
		{"dataIndex": ["modby", "name"], "title": "Modif.", "width": 100, "options": {"type": "text", "sortable": true, "searchable": true}},  	
		{dataIndex: "last",      title: ""},
	];

	return <Tabler
		{...props} 
		columns={columns}
		entity='TUser' 
		sortData={[{'field': "name", "direction": "asc"}]}
		url='/dataservice'
		ref={ref}
	/>;
});

export default TableUser;
